import { PresencialidadEnum, SelectOption } from "../../types/types"
import Select from 'react-select'
import { RiDeleteBack2Line } from 'react-icons/ri';
import { useRecoilState } from 'recoil';
import { consultaModo} from '../../atoms/mainAtoms';
import { utilMethods } from "../../utils/utilMethods";

export function PresencialidadField({ id, label, value, setValue, setFilterPropValue, reduced}: {
    id: string, label: string,
    value?: string | undefined,
    setValue?: React.Dispatch<React.SetStateAction<string | undefined>>,
    setFilterPropValue?: (value: string | boolean | undefined, property: string) => void,
    reduced?:boolean
}) {

    const getOptionFromValue = (value: string): SelectOption => {
        return { value: value, label: utilMethods.getPresencialidadLabel(value) }
    }


    const getOptions = () => {
        const options: SelectOption[] = []
        Object.values(PresencialidadEnum).forEach((option) => {
            options.push(getOptionFromValue(option))
        })
        return options
    }

    const options = getOptions()
    
    const [modoConsulta, setModoConsulta] = useRecoilState<boolean>(consultaModo)
    
    return (
         <div className={'selectFieldBox'}>
            <label>{label}</label>
            <div className='filterAndBut'>
            <select style={{ width: reduced ? '60%' : '100%' }} disabled={modoConsulta || (!setValue && !setFilterPropValue) ? true : false} className='selectField' value={value}
                    onChange={setValue ? (e) => setValue(e?.target.value !== '0' ? e?.target.value : undefined ) : 
                    setFilterPropValue ? (e) => setFilterPropValue(e?.target.value === '0' ? undefined : e?.target.value, id) : undefined} >
                    <option selected={true} value={'0'}>{'Seleccionar presencialidad'}</option>
                    {options.map((option) =>
                        <option value={option.value}>{option.label}</option>
                    )}
                </select>
                {setFilterPropValue ?
                    <button className='deleteFilterBut' onClick={() => setFilterPropValue(undefined, id)}><RiDeleteBack2Line /></button>
                    :
                    <></>
                }
            </div>
            </div>
    )

}